'use strict';

/**
 * @classname GA4SelectItem
 * @classdesc GA4 商品選択
 */
export default class GA4SelectItem {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-category .card--item .anchor:not(.anchor--favorite)
	 * @param {jQuery} $e - .page-category .card--item .anchor--item-name
	 * @param {jQuery} $e - .page-search .card--item .anchor:not(.anchor--favorite)
	 * @param {jQuery} $e - .page-search .card--item .anchor--item-name
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._href = $e.attr('href');
		this._itemCd = $e.closest('.card--item').attr('data-item-code');
		$e.on('click', (e) => this.onClick(e));
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof GA4SelectItem
	 * @return undefined
	 */
	onClick(e) {
		console.log(`${this.constructor.name}.onClick`);
		if(window.dataLayer) {
			// dataLayerがある場合
			e.preventDefault();
			e.stopPropagation();
			let product = null;
			let eCommerce;
			for (let i = 0; i < window.dataLayer.length; i++) {
				if (window.dataLayer[i].event === 'view_item_list') eCommerce = window.dataLayer[i].ecommerce;
			}
			const items = eCommerce.items;
			console.log(items);
			for (let i = 0; i < items.length; i++) {
				if (items[i].item_id === this._itemCd) product = items[i];
			}
			if(product){
				// 商品リストの商品がクリックされた場合
				window.dataLayer.push({
					event: 'select_item',
					ecommerce: {
						items: [
							product
						]
					},
					'eventCallback': () => {
						// DataLayerにデータを送信後に通常処理へ
						location.href = this._href;
					},
					'eventTimeout' : 2000
				});
				// timeoutしたらそのまま遷移
				setTimeout(() => {
					location.href = this._href;
				}, 2500);
			}else{
				// 商品リスト以外の商品がクリックされた場合
				location.href = this._href;
			}
		}
		// dataLayerがない場合はそのまま遷移
	};
};
